import { useEffect, useState } from 'react';

import type { NotificationType } from '~/interfaces/notification';

import { usePageContext } from '~/context/usePageContext';

interface ReturnProps {
  readNotifications: string[];
  readNotificationsCount: number;
  handleReadNotification: (notificationId: string) => void;
  handleReadAllNotifications: (notifications: NotificationType[]) => void;
}

const useReadNotifications = (): ReturnProps => {
  const { cookies, cookiesSet, setCookie } = usePageContext();
  const [readNotifications, setReadNotifications] = useState<string[]>([]);

  useEffect(() => {
    if (cookiesSet && cookies?.notifications_read) {
      setReadNotifications(JSON.parse(cookies?.notifications_read));
    }
  }, [cookiesSet, cookies]);

  const handleReadNotification = (notificationId: string) => {
    const updatedReadNotifications = JSON.stringify([...readNotifications, notificationId]);
    setCookie({
      name: 'notifications_read',
      value: updatedReadNotifications,
      days: 4,
    });
  };

  const handleReadAllNotifications = (notifications: NotificationType[]) => {
    const notificationIds = notifications.map((notification) => notification.id);
    const updatedReadNotifications = JSON.stringify(notificationIds);
    setCookie({
      name: 'notifications_read',
      value: updatedReadNotifications,
      days: 4,
    });
  };

  return {
    readNotifications,
    readNotificationsCount: readNotifications.length,
    handleReadNotification,
    handleReadAllNotifications,
  };
};

export default useReadNotifications;
